var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcCloseBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "n5ugoiah7a",
    d: "M17.417 5.876L16.124 4.583 11 9.707 5.876 4.583 4.583 5.876 9.707 11 4.583 16.124 5.876 17.417 11 12.293 16.124 17.417 17.417 16.124 12.293 11z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gfwfni6p7b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n5ugoiah7a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1890FF",
    mask: "url(#gfwfni6p7b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.833V45.833H0z",
    transform: "translate(-11.917 -11.917)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloseBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-close-blue.9cad14ea.svg";
export { ForwardRef as ReactComponent };